export const initPriceListRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/pricelist",
          name: "pricelist",
          component: () => import("@/pages/manage/price-lists/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/pricelist/:id",
          name: "pricelist-id",
          component: () => import("@/pages/manage/price-lists/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
